// import { analyticsCB } from "@/components/cart/cartAnalytics"

export const removeFromCart = (data = {}) => {
  /**
   * It removeFrom cart for pay load
   */
  const {
    lineItemId = "",
    quantity = 0,
    isBundle = false,
    isBundleParent = false,
    sku = "",
  } = data

  const bundlePayload = {
    action: "removeBundleItem",
    customLineItemId: lineItemId,
    sku,
  }

  const actions = [
    isBundleParent
      ? bundlePayload
      : {
          action: isBundle ? "removebundle" : "removeLineItem",
          lineItemId,
          quantity,
        },
  ]

  return actions
}

export const setRemoveCartPayload = (items = []) => {
  /**
   * It removeFrom cart for payload removeBundleItem
   */
  const actions = []
  const allIds = items.filter(item => item.id).map(item => item.id)
  items.forEach(item => {
    const {
      id = "",
      sku = "",
      quantity = 0,
      isComboSku = false,
      bundleParentId = "",
      parentBundleSku = "",
      parentBundleId = "",
      isBundleParent = false,
      isBundleChildItem = false,
    } = item

    const filteredIds = allIds.filter(i => i !== id)
    const isChildItem = parentBundleSku && isBundleChildItem
    // filtering out the combo sku items, to select only parent item if available
    if (
      !filteredIds.includes(bundleParentId) &&
      !parentBundleSku &&
      !isBundleParent
    ) {
      actions.push({
        action:
          isComboSku || bundleParentId ? "removebundle" : "removeLineItem",
        lineItemId: bundleParentId || id,
        quantity,
      })
    } else if ((!parentBundleSku && isBundleParent) || isChildItem) {
      // Handle static bundles and bundle child items
      actions.push({
        action: "removeBundleItem",
        customLineItemId: isChildItem ? parentBundleId : id,
        sku: isChildItem ? parentBundleSku : sku,
      })
    }
  })

  return actions
}
